import { produits } from '@workspace/api';
import { getLabelFromValue } from '@workspace/utils';
import { Bike, Boxes, FileText, Motorbike, Scooter, Trees, Zap, type LucideIcon } from 'lucide-react';

export function getProductIcon(codeProduit: string | null): LucideIcon {
    const lowerLabel = getLabelFromValue(produits, codeProduit).toLowerCase();

    if (lowerLabel.includes('vélo') || lowerLabel.includes('velo')) return Bike;
    if (lowerLabel.includes('trottinette') && lowerLabel.includes('mae')) return Zap;
    if (lowerLabel.includes('trottinette')) return Scooter;
    if (lowerLabel.includes('quad') || lowerLabel.includes('verte')) return Trees;
    if (lowerLabel.includes('moto') || lowerLabel.includes('scooter') || lowerLabel.includes('cyclo')) return Motorbike;
    if (lowerLabel.includes('livraison')) return Boxes;

    return FileText;
}
